import { api } from '../api/client';
import { API_USERS_URL } from '../utils';

/**
 * The signed-in account's own plan (keepr-api docs/SCHEMA.md "Plans: reading
 * your plan and a collection's limits"; KPR-1095):
 *
 *   { plan, name, fileBytes, meters: [{ meter, unit, limit, used, asOf }] }
 *
 * `limit` null is no fixed number; `used` null is not measured yet. Asked
 * only while plans are visible (config/plans.js) — see hooks/usePlan.js.
 */
export async function getMyPlan() {
	const { data } = await api.get(`${API_USERS_URL}/me/plan`);
	return data;
}

export default getMyPlan;
